// import rp from "request-promise"; // this request enables multipart upload for image upload
export const executeAPIRequest = async (
  apiConfig,
  methodType,
  headerOptions = {},
  bodyContents
) => {
  let getResponse;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `SYF ${apiConfig.jwtToken}`,
    ...headerOptions,
  };

  let { base } = bodyContents || {};

  bodyContents = base
    ? (({ base, ...otherKeys }) => ({ ...otherKeys }))(bodyContents)
    : bodyContents;
  getResponse = await fetch(apiConfig.url, {
    headers: headers,
    method: methodType,
    dataType: "json",
    body:
      (methodType === "POST" ||
        methodType === "PATCH" ||
        methodType === "PUT" ||
        methodType === "DELETE") &&
      bodyContents
        ? JSON.stringify(bodyContents)
        : undefined,
  });
  return getResponse;
};
